import PropTypes from "prop-types";
import { useEffect, useState } from "react";

export function BrowserFeature({ children }) {
  const [isBrowser, setIsBrowser] = useState(false);
  useEffect(() => {
    if (typeof window !== "undefined") {
      setIsBrowser(true);
    }
  }, []);
  return isBrowser ? children : null;
}

BrowserFeature.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
};
